<rav-modal modalTitle="Create New Folder" [modalId]="modalId">
  <rav-form
    [formGroup]="formGroup"
    (formSubmit)="createFolder($event)"
    [fields]="[{ name: 'title' }]"
    [hasCancel]="true"
    (cancel)="modal.close.next({ modalId: modalId, canceled: true })"
    buttonText="Create Folder"
  ></rav-form>
</rav-modal>
